import { cn } from '@/lib/cn'

export interface StatCardProps {
  label: string
  value: string | number
  currency?: string
  className?: string
}

export function StatCard({ label, value, currency, className }: StatCardProps): React.ReactElement {
  const formatted =
    typeof value === 'number'
      ? value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : value

  return (
    <div
      className={cn(
        'rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800',
        className,
      )}
    >
      <p className="text-xs font-medium text-gray-500 dark:text-gray-400">{label}</p>
      <p className="mt-1 text-xl font-semibold text-gray-900 dark:text-gray-100">
        {currency && <span className="mr-1 text-sm font-normal text-gray-400">{currency}</span>}
        {formatted}
      </p>
    </div>
  )
}

StatCard.displayName = 'StatCard'
